"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSettings = void 0;
exports.defaultSettings = {
    site_id: "",
    property_id: "",
    analytics: {
        bigcrunch: true,
        prebid_analytics: false,
        bigcrunch_page_meta: true,
        url_path_groupings: [],
        page_meta_overrides: {}
    },
    gam_advertiser_ids: {},
    site_name: "",
    slots: {},
    bidders: {},
    user_syncs: {},
    schain: {
        complete: 1,
        nodes: [],
        ver: "1.0"
    },
    coppa: false,
    test: {
        enabled: false,
        ids: false,
        ads: false,
        bidders: [],
    }
};
